import { Card, CardContent, Grid } from '@mui/material'
import Phone from '@mui/icons-material/Phone'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'

const contactItems = [
    {
        id: 'phone',
        label: 'شماره تماس پشتیبانی پتروکارت',
        value: '02191095829',
        href: 'tel:02191095829',
        icon: <Phone sx={{ fontSize: 22 }} />,
        external: false
    },
    {
        id: 'chatbot',
        label: 'چت بات پتروکارت',
        value: 'mu.chat/@petrocart',
        href: 'https://mu.chat/@petrocart',
        icon: <i className="fal fa-comments"></i>,
        external: true
    },
    {
        id: 'bale',
        label: 'گروه بله',
        value: 'ble.ir/petrocard',
        href: 'https://ble.ir/petrocard',
        icon: <i className="fal fa-users"></i>,
        external: true
    },
    {
        id: 'instagram',
        label: 'پیج اینستاگرام',
        value: 'petro.card',
        href: 'https://instagram.com/petro.card',
        icon: <i className="fab fa-instagram"></i>,
        external: true
    },
    {
        id: 'videos',
        label: 'فیلم های آموزشی پتروکارت',
        value: 'posc.ir/petrocard/amoozesh',
        href: 'https://www.posc.ir/fa/petrocard/amoozesh',
        icon: <i className="fal fa-play-circle"></i>,
        external: true
    },
    {
        id: 'eitaa',
        label: 'کانال ایتا',
        value: '@petrocard',
        href: 'https://eitaa.com/petrocard',
        icon: <i className="fal fa-paper-plane"></i>,
        external: true
    }
]

const ContactUs = () => {
    return (
        <Grid item px={0.3}>
            <h3 className="others-page-title">تماس با ما</h3>
            <div className="safe-area">
                <Card sx={{ width: '100%', mb: 5 }} className="business-item contact-us-card">
                    <CardContent sx={{ pb: '16px !important', pt: 1 }}>
                        {contactItems.map((item, index) => (
                            <a
                                key={item.id}
                                href={item.href}
                                className={`contact-us-item${index === contactItems.length - 1 ? ' contact-us-item-last' : ''}`}
                                {...(item.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                            >
                                <span className="contact-us-icon">{item.icon}</span>
                                <span className="contact-us-text">
                                    <span className="contact-us-label">{item.label}</span>
                                    <span className="contact-us-value">{item.value}</span>
                                </span>
                                <span className="contact-us-action">
                                    {item.external ? <OpenInNewIcon sx={{ fontSize: 18 }} /> : <Phone sx={{ fontSize: 18 }} />}
                                </span>
                            </a>
                        ))}
                    </CardContent>
                </Card>
            </div>
        </Grid>
    )
}

export default ContactUs
